import { PerformanceReviewVersion } from '@/common/graphql';

export enum PerformanceReviewTab {
  OVERVIEW = 'overview',
  PERFORMANCE_TARGET = 'performance-target',
  MY_MISSION = 'my-mission',
  VALUES = 'values',
  MY_DEVELOPMENT_PLAN = 'my-development-plan',
  GROWTH_TARGET = 'growth-target',
  SETTING = 'setting',
}

export class PerformanceReviewLabels {
  public static PERFORMANCE_TARGET: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Performance Targets',
    [PerformanceReviewVersion.Version_2]: 'My Mission (Target)',
  };

  public static SALES_TARGET: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Sales Target',
    [PerformanceReviewVersion.Version_2]: 'Sales Target',
  };

  public static SALES_TARGET_SUB_LABEL = '(GP & Revenue)';

  public static OTHER_TARGET: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Other Target',
    [PerformanceReviewVersion.Version_2]: 'Other Target',
  };

  public static MISSION_CATEGORY_SINGLE: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Single KPI',
    [PerformanceReviewVersion.Version_2]: 'Single-KPI Mission',
  };

  public static SINGLE_MISSION_KPI: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'KPI',
    [PerformanceReviewVersion.Version_2]: 'My Mission (Target)',
  };

  public static SINGLE_MISSION_TARGET_TYPE: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Target Type',
    [PerformanceReviewVersion.Version_2]: 'Mission Type',
  };

  public static MISSION_CATEGORY_MULTIPLE: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Multiple KPIs',
    [PerformanceReviewVersion.Version_2]: 'Multiple-KPI Mission',
  };

  public static GROWTH_TARGET: Record<PerformanceReviewVersion, string> = {
    [PerformanceReviewVersion.Version_1]: 'Growth Target',
    [PerformanceReviewVersion.Version_2]: 'My Development Plan',
  };
}

export const PerformanceReviewTabLabels: Record<PerformanceReviewTab, string> = {
  [PerformanceReviewTab.OVERVIEW]: 'Overview',
  [PerformanceReviewTab.PERFORMANCE_TARGET]:
    PerformanceReviewLabels.PERFORMANCE_TARGET[PerformanceReviewVersion.Version_1],
  [PerformanceReviewTab.MY_MISSION]: PerformanceReviewLabels.PERFORMANCE_TARGET[PerformanceReviewVersion.Version_2],
  [PerformanceReviewTab.VALUES]: 'Values',
  [PerformanceReviewTab.GROWTH_TARGET]: PerformanceReviewLabels.GROWTH_TARGET[PerformanceReviewVersion.Version_1],
  [PerformanceReviewTab.MY_DEVELOPMENT_PLAN]: PerformanceReviewLabels.GROWTH_TARGET[PerformanceReviewVersion.Version_2],
  [PerformanceReviewTab.SETTING]: 'Setting',
};
